import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'timePickerFocusedValuePipe'})
export class TimePickerFocusedValuePipe implements PipeTransform {
  transform(value: any): string {
    return value || '';
  }
}
